import { IonActionSheet } from '@ionic/react';
import styled from 'styled-components';

export const StyledActionSheet = styled(IonActionSheet)`
  --button-background-selected: var(--allie-color-neutral-20);
  --button-color-selected: var(--allie-color-neutral-20);

  .allie-action-sheet .action-sheet-group-cancel {
    display: none;
  }
`;
